import { atom } from 'jotai';
import type { AuthSource } from '~/modules/user/type';
export const uiStateAtomLoginModalOpened = atom(false);
export const uiStateAtomLoginModalAuthSource = atom<AuthSource | null>(null);
